import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserType } from 'src/app/shared/constants/user-type.enum';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../../../providers/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/providers/storage.service';
import { BlockUnblockUsersComponent } from '../block-unblock-users/block-unblock-users.component';
import { SharedService } from '../../../providers/shared.service';

@Component({
  selector: 'sm-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.scss']
})
export class AllUsersComponent implements OnInit, OnDestroy {
  usersList: any[] = [];
  imageThumbUrl: string = environment.profileImageBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "location",
      columnProperty: "state"
    },
    {
      columnName: "type",
      columnProperty: "userType"
    },
    {
      columnName: "phone",
      columnProperty: "phone"
    },
    
    {
      columnName: "status",
      columnProperty: "stat"
    }
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService,private _apiService: ApiService, private _dialog: MatDialog, private _navService: NavigationService, private route: ActivatedRoute, private router: Router, private _storageService: StorageService) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      console.log(resData);
      
      if(resData.responseType === SM_CONSTANTS.GET_ALL_USERS_RESULT){
        console.log(resData);
        resData.result.forEach((element:any) => {
          if(element.profileStatus == 1){
            element.stat = 'active'
          }
          else if(element.profileStatus == 2){
            element.stat = 'blocked'
          }
        });
        this.usersList = resData.result ? resData.result : [];
        this.usersList.map(user => {
          user.userType = UserType[user.userType]
        });
      }
    });
  }

  ngOnInit(): void {
    this._apiService.getAllUsers();
  }

  viewProfile(profileData: any){
    this._dialog.open(UserProfileComponent, {
      data: profileData,
      maxWidth: 370,
      panelClass: 'user-profile-dialog'
    });
  }
  viewBusiness(value: any){
    console.log("click");
    this._storageService.setValueInAppStorage('specificEntityHash', value.hashId)
    this._storageService.setValueInAppStorage('specificEntityName', value.name)
    this.router.navigate(['entity-business'], {relativeTo: this.route})
    
  }

  blockUsers(rowvalue:any){
    rowvalue.type = 'block'
    this._dialog.open(BlockUnblockUsersComponent, {
      data: rowvalue,
      
    })
  }
  unblockUsers(rowvalue:any){
    rowvalue.type = 'unblock'
    this._dialog.open(BlockUnblockUsersComponent, {
      data: rowvalue,
      
    })
  }

  ngOnDestroy(){
    this._apiSubscription.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

}
